import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Paper,
  Avatar,
  Breadcrumbs,
  Link as MuiLink,
  Fade,
  Slide,
  LinearProgress,
  Chip
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  Business as BusinessIcon,
  People as PeopleIcon,
  TrendingUp as TrendingUpIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  Nature as EcoIcon,
  Star as StarIcon,
  LocalShipping as LocalShippingIcon,
  Store as StoreIcon,
  ShoppingCart as ShoppingCartIcon,
  Verified as VerifiedIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const About = () => {
  const companyStats = [
    {
      icon: <PeopleIcon sx={{ fontSize: 48 }} />,
      value: '১০ লক্ষ+',
      label: 'সন্তুষ্ট গ্রাহক',
      color: '#4CAF50'
    },
    {
      icon: <StoreIcon sx={{ fontSize: 48 }} />,
      value: '৫০,০০০+',
      label: 'বিক্রেতা',
      color: '#2196F3'
    },
    {
      icon: <ShoppingCartIcon sx={{ fontSize: 48 }} />,
      value: '১ কোটি+',
      label: 'পণ্য বিক্রি',
      color: '#FF9800'
    },
    {
      icon: <LocalShippingIcon sx={{ fontSize: 48 }} />,
      value: '৬৪টি',
      label: 'জেলায় সেবা',
      color: '#9C27B0'
    }
  ];

  const coreValues = [
    {
      icon: <SecurityIcon />,
      title: 'বিশ্বস্ততা',
      description: 'আমরা গ্রাহকদের সাথে স্বচ্ছতা এবং বিশ্বস্ততার সাথে কাজ করি',
      color: '#4CAF50'
    },
    {
      icon: <SpeedIcon />,
      title: 'দ্রুততা',
      description: 'দ্রুত ডেলিভারি এবং তাৎক্ষণিক সেবা প্রদান আমাদের অগ্রাধিকার',
      color: '#2196F3'
    },
    {
      icon: <StarIcon />,
      title: 'গুণগত মান',
      description: 'উন্নত মানের পণ্য এবং সেবা নিশ্চিত করা আমাদের লক্ষ্য',
      color: '#FF9800'
    },
    {
      icon: <EcoIcon />,
      title: 'পরিবেশ বান্ধব',
      description: 'পরিবেশ রক্ষায় আমরা টেকসই ব্যবসায়িক পদ্ধতি অনুসরণ করি',
      color: '#9C27B0'
    }
  ];

  const teamMembers = [
    {
      name: 'মোহাম্মদ রহিম',
      position: 'প্রতিষ্ঠাতা ও সিইও',
      image: '/api/placeholder/150/150',
      description: 'ই-কমার্স ক্ষেত্রে ১৫ বছরের অভিজ্ঞতা'
    },
    {
      name: 'ফাতেমা খাতুন',
      position: 'প্রযুক্তি পরিচালক',
      image: '/api/placeholder/150/150',
      description: 'সফটওয়্যার ইঞ্জিনিয়ারিংয়ে ১২ বছরের অভিজ্ঞতা'
    },
    {
      name: 'আহমেদ হাসান',
      position: 'বিপণন পরিচালক',
      image: '/api/placeholder/150/150',
      description: 'ডিজিটাল মার্কেটিংয়ে ১০ বছরের অভিজ্ঞতা'
    },
    {
      name: 'সালমা বেগম',
      position: 'গ্রাহক সেবা প্রধান',
      image: '/api/placeholder/150/150',
      description: 'কাস্টমার সার্ভিসে ৮ বছরের অভিজ্ঞতা'
    }
  ];

  const milestones = [
    {
      year: '২০১৮',
      title: 'প্রতিষ্ঠা',
      description: 'গ্রামীণ বাজারের যাত্রা শুরু ঢাকায় ছোট একটি অফিস থেকে'
    },
    {
      year: '২০১৯',
      title: 'সম্প্রসারণ',
      description: 'চট্টগ্রাম ও সিলেটে সেবা বিস্তার'
    },
    {
      year: '২০২০',
      title: 'ডিজিটাল রূপান্তর',
      description: 'মোবাইল অ্যাপ লঞ্চ এবং অনলাইন পেমেন্ট সিস্টেম চালু'
    },
    {
      year: '২০২১',
      title: 'জাতীয় সম্প্রসারণ',
      description: 'সারাদেশে ৬৪টি জেলায় সেবা পৌঁছানো'
    },
    {
      year: '২০২২',
      title: 'আন্তর্জাতিক স্বীকৃতি',
      description: 'এশিয়ার সেরা ই-কমার্স প্ল্যাটফর্ম পুরস্কার'
    },
    {
      year: '২০২৩',
      title: 'এআই ইন্টিগ্রেশন',
      description: 'কৃত্রিম বুদ্ধিমত্তা ভিত্তিক পণ্য সুপারিশ সিস্টেম'
    }
  ];

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container>
            <Breadcrumbs 
              separator={<NavigateNextIcon fontSize="small" />} 
              aria-label="breadcrumb"
              sx={{ mb: 4, '& .MuiBreadcrumbs-separator': { color: 'rgba(255,255,255,0.7)' } }}
            >
              <MuiLink component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                হোম
              </MuiLink>
              <Typography sx={{ color: 'white' }}>আমাদের সম্পর্কে</Typography>
            </Breadcrumbs>

            <Fade in timeout={1000}>
              <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                  আমাদের সম্পর্কে
                </Typography>
                <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: '800px', mx: 'auto' }}>
                  বাংলাদেশের সবচেয়ে বিশ্বস্ত অনলাইন মার্কেটপ্লেস হিসেবে আমরা গ্রামীণ জনগোষ্ঠীর কাছে আধুনিক প্রযুক্তির সুবিধা পৌঁছে দিচ্ছি
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>

        <Container sx={{ py: 6 }}>
          {/* Company Stats */}
          <Box sx={{ mb: 8 }}>
            <Grid container spacing={4}>
              {companyStats.map((stat, index) => (
                <Grid item xs={6} md={3} key={index}>
                  <Slide direction="up" in timeout={500 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-8px)',
                          boxShadow: '0 12px 24px rgba(0,0,0,0.15)'
                        },
                        border: '1px solid #e2e8f0'
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: stat.color,
                          width: 80,
                          height: 80,
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        {stat.icon}
                      </Avatar>
                      <Typography variant="h3" sx={{ fontWeight: 700, color: stat.color, mb: 1 }}>
                        {stat.value}
                      </Typography>
                      <Typography variant="h6" color="text.secondary">
                        {stat.label}
                      </Typography>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Mission & Vision */}
          <Grid container spacing={6} sx={{ mb: 8 }}>
            <Grid item xs={12} md={6}>
              <Fade in timeout={1000}>
                <Paper sx={{ p: 4, height: '100%', border: '1px solid #e2e8f0' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: '#4CAF50', mr: 2, width: 56, height: 56 }}>
                      <TrendingUpIcon />
                    </Avatar>
                    <Typography variant="h4" sx={{ fontWeight: 600 }}>
                      আমাদের লক্ষ্য
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ lineHeight: 1.8, fontSize: '1.1rem' }}>
                    বাংলাদেশের প্রতিটি গ্রামে ডিজিটাল বাণিজ্যের সুবিধা পৌঁছে দেওয়া এবং স্থানীয় উৎপাদকদের জাতীয় ও আন্তর্জাতিক বাজারে প্রবেশের সুযোগ তৈরি করা। আমরা চাই প্রযুক্তির মাধ্যমে গ্রামীণ অর্থনীতিকে শক্তিশালী করতে।
                  </Typography>
                </Paper>
              </Fade>
            </Grid>
            <Grid item xs={12} md={6}>
              <Fade in timeout={1200}>
                <Paper sx={{ p: 4, height: '100%', border: '1px solid #e2e8f0' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: '#2196F3', mr: 2, width: 56, height: 56 }}>
                      <BusinessIcon />
                    </Avatar>
                    <Typography variant="h4" sx={{ fontWeight: 600 }}>
                      আমাদের দৃষ্টিভঙ্গি
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ lineHeight: 1.8, fontSize: '1.1rem' }}>
                    ২০৩০ সালের মধ্যে দক্ষিণ এশিয়ার সবচেয়ে বড় এবং বিশ্বস্ত ই-কমার্স প্ল্যাটফর্ম হয়ে ওঠা। আমরা এমন একটি ডিজিটাল ইকোসিস্টেম তৈরি করতে চাই যেখানে ক্রেতা-বিক্রেতা সবাই সমানভাবে উপকৃত হবেন।
                  </Typography>
                </Paper>
              </Fade>
            </Grid>
          </Grid>

          {/* Core Values */}
          <Box sx={{ mb: 8, pt: '50px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              আমাদের মূল্যবোধ
            </Typography>
            <Grid container spacing={4}>
              {coreValues.map((value, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Slide direction="up" in timeout={800 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0'
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: value.color,
                          width: 64,
                          height: 64,
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        {value.icon}
                      </Avatar>
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                        {value.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                        {value.description}
                      </Typography>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Company Story */}
          <Box sx={{ mb: 8, pt: '50px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              আমাদের গল্প
            </Typography>
            <Fade in timeout={1400}>
              <Paper sx={{ p: 6, border: '1px solid #e2e8f0' }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                  একটি স্বপ্ন থেকে বাস্তবতায়
                </Typography>
                <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: '1.1rem' }}>
                  ২০১৮ সালে, কয়েকজন তরুণ উদ্যোক্তার একটি স্বপ্ন ছিল - বাংলাদেশের গ্রামীণ এলাকার মানুষদের কাছে আধুনিক প্রযুক্তির সুবিধা পৌঁছে দেওয়া। তারা দেখেছিলেন যে শহরের মানুষরা অনলাইন শপিংয়ের সুবিধা পাচ্ছেন, কিন্তু গ্রামের মানুষরা এই সুবিধা থেকে বঞ্চিত।
                </Typography>
                <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: '1.1rem' }}>
                  এই চিন্তা থেকেই জন্ম নেয় "গ্রামীণ বাজার"। আমাদের লক্ষ্য ছিল সহজ, কিন্তু চ্যালেঞ্জিং - প্রতিটি গ্রামে পৌঁছানো এবং স্থানীয় উৎপাদকদের তাদের পণ্য বিক্রির জন্য একটি বিশ্বস্ত প্ল্যাটফর্ম দেওয়া।
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, fontSize: '1.1rem' }}>
                  আজ, পাঁচ বছর পর, আমরা গর্বিত যে আমরা ১০ লক্ষেরও বেশি গ্রাহকের সেবা করছি এবং ৫০,০০০+ বিক্রেতার সাথে কাজ করছি। আমাদের যাত্রা এখনও শেষ হয়নি - আমরা প্রতিদিন নতুন স্বপ্ন দেখি এবং সেগুলো বাস্তবায়নে কাজ করি।
                </Typography>
              </Paper>
            </Fade>
          </Box>

          {/* Timeline */}
          <Box sx={{ mb: 8 }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              আমাদের যাত্রাপথ
            </Typography>
            <Grid container spacing={3}>
              {milestones.map((milestone, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Slide direction="up" in timeout={1000 + index * 200}>
                    <Card
                      sx={{
                        p: 3,
                        height: '100%',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0'
                      }}
                    >
                      <Chip
                        label={milestone.year}
                        color="primary"
                        sx={{ mb: 2, fontWeight: 600 }}
                      />
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        {milestone.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                        {milestone.description}
                      </Typography>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Team Section */}
          <Box sx={{ mb: 8 }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              আমাদের টিম
            </Typography>
            <Grid container spacing={4}>
              {teamMembers.map((member, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Fade in timeout={1200 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0'
                      }}
                    >
                      <Avatar
                        src={member.image}
                        sx={{
                          width: 120,
                          height: 120,
                          mx: 'auto',
                          mb: 2,
                          border: '4px solid #e2e8f0'
                        }}
                      />
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        {member.name}
                      </Typography>
                      <Typography variant="subtitle1" color="primary.main" sx={{ mb: 1, fontWeight: 500 }}>
                        {member.position}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {member.description}
                      </Typography>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Call to Action */}
          <Paper
            sx={{
              p: 6,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderRadius: 3
            }}
          >
            <VerifiedIcon sx={{ fontSize: 64, mb: 2, opacity: 0.9 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              আমাদের সাথে যুক্ত হন
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9, maxWidth: '600px', mx: 'auto' }}>
              গ্রামীণ বাজারের সাথে আপনার ব্যবসা বাড়ান অথবা আমাদের টিমে যোগ দিয়ে দেশের উন্নয়নে অবদান রাখুন
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <MuiLink
                component={Link}
                to="/career"
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'grey.100'
                  }
                }}
              >
                ক্যারিয়ার সুযোগ দেখুন
              </MuiLink>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  border: '2px solid white',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                যোগাযোগ করুন
              </MuiLink>
            </Box>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default About; 